import React from "react";

/**
 * Skeleton component for loading placeholders.
 * Usage: <Skeleton className="h-6 w-1/2 mb-2" />
 */
export function Skeleton({ className = "" }) {
  return (
    <div
      className={`bg-gray-200 rounded ${className} animate-pulse`}
      aria-hidden="true"
    />
  );
}
